module.exports = __webpack_public_path__ + "static/media/TJ-Can.a5eeae82.svg";